
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/integrations/[slug]/topics/[topicSlug]",
      function () {
        return require("private-next-pages/integrations/[slug]/topics/[topicSlug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/integrations/[slug]/topics/[topicSlug]"])
      });
    }
  